/**
 * Merge-tier PNG URLs resolved at build time (only active evolution tiers ship).
 */
import cellUrl from "./merge/v2/scaled/cell.png?url";
import starfishUrl from "./merge/v2/scaled/starfish.png?url";
import jellyfishUrl from "./merge/v2/scaled/jellyfish.png?url";
import fishUrl from "./merge/v2/scaled/fish.png?url";
import snailUrl from "./merge/v2/scaled/snail.png?url";
import bugUrl from "./merge/v2/scaled/bug.png?url";
import butterflyUrl from "./merge/v2/scaled/butterfly.png?url";
import lizardUrl from "./merge/v2/scaled/lizard.png?url";
import pterodactylUrl from "./merge/v2/scaled/pterodactyl.png?url";
import trexUrl from "./merge/v2/scaled/trex.png?url";
import dragonFinalUrl from "./merge/v2/scaled/dragon_final.png?url";

var TIER_URLS = {
  cell: cellUrl,
  starfish: starfishUrl,
  jellyfish: jellyfishUrl,
  fish: fishUrl,
  snail: snailUrl,
  bug: bugUrl,
  butterfly: butterflyUrl,
  lizard: lizardUrl,
  pterodactyl: pterodactylUrl,
  trex: trexUrl,
  dragon_final: dragonFinalUrl,
};

/**
 * @param {string} assetId
 * @returns {string}
 */
export function mergeTierImageUrl(assetId) {
  var id = String(assetId || "").trim();
  if (!id) return "";
  return TIER_URLS[id] || "";
}

/**
 * @param {string[]} assetIds
 * @returns {string[]}
 */
export function mergeTierImageUrls(assetIds) {
  var seen = {};
  var out = [];
  for (var i = 0; i < assetIds.length; i++) {
    var url = mergeTierImageUrl(assetIds[i]);
    if (!url || seen[url]) continue;
    seen[url] = true;
    out.push(url);
  }
  return out;
}

/** @returns {string[]} */
export function allBundledMergeTierImageUrls() {
  return Object.keys(TIER_URLS).map(function (key) {
    return TIER_URLS[key];
  });
}